'use strict';

export const defaultState = () => ({});

export const state = () => defaultState();

export const getters = {};

export const mutations = {};

export const actions = {
    show(ctx, id) {
        return this.$axios.$get(`/media/${id}`);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
